// extracted by mini-css-extract-plugin
export default {"container":"tUwQh","borderless":"dMfiA","categories":"e8FTY","autoPromoButton":"FwtHk"};